import { render, staticRenderFns } from "./acquista.vue?vue&type=template&id=33531d05&scoped=true&"
import script from "./acquista.vue?vue&type=script&lang=ts&"
export * from "./acquista.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33531d05",
  null
  
)

export default component.exports